import type { Papel } from "@ghm/domain";

import { http, request } from "@/lib/http";

/**
 * Pessoas da organização.
 *
 * A organização NÃO viaja nestas chamadas: o servidor a tira da sessão. Mandar
 * o id daqui seria dar ao cliente a chance de apontar para outra empresa — e
 * como o papel vai junto no cadastro, seria a chance de se dar acesso de
 * administrador lá.
 */
export interface Membro {
  userId: string;
  login: string;
  nome: string;
  email: string | null;
  papel: Papel;
  ativo: boolean;
  criadoEm: string;
}

export interface NovoMembro {
  login: string;
  nome: string;
  email?: string | null;
  senha: string;
  papel: Papel;
}

export async function listarMembros(signal?: AbortSignal): Promise<Membro[]> {
  const resposta = await http.get<{ membros: Membro[] }>("/api/organizacao/membros", {
    signal,
  });
  return resposta.membros;
}

export async function cadastrarMembro(entrada: NovoMembro): Promise<Membro> {
  const resposta = await http.post<{ membro: Membro }>(
    "/api/organizacao/membros",
    entrada,
  );
  return resposta.membro;
}

export interface MembroRemovido {
  userId: string;
  removido: true;
  /** `true` = a pessoa nao pertencia a mais nenhuma empresa e a conta foi apagada. */
  contaApagada: boolean;
}

/**
 * DELETE /api/organizacao/membros/:userId — tira a pessoa da organização.
 *
 * O servidor recusa remover a si mesmo (400) e o último admin (409); a tela
 * mostra a mensagem que vier, em vez de repetir a regra por conta própria.
 */
export function removerMembro(userId: string): Promise<MembroRemovido> {
  return request<MembroRemovido>(`/api/organizacao/membros/${encodeURIComponent(userId)}`, {
    method: "DELETE",
  });
}

/**
 * POST /api/organizacao/enviar-painel — o painel de quem pede substitui o dos
 * destinatários, em todos os setores (U10). A origem e a empresa saem da sessão.
 */
export async function enviarPainel(destinatarios: string[]): Promise<{ destinatarios: number }> {
  return http.post<{ destinatarios: number }>("/api/organizacao/enviar-painel", { destinatarios });
}
